import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { StatsSection } from '../common/stats-section';
import { StatNavItem, SeasonNavItem } from './components/nav-items';
import { Heading, DataTypeToggle } from './components/header';
import { BenchmarkingExplainer, BenchmarkingLegend } from '../../../../../../common/react/components/benchmarking';
import { PerformanceChartContainer } from './components/chart';

import { usePerformanceChartNavSync } from './hooks/use-performance-chart-nav-sync';
import { useCompetitionNavigationOptions } from '../../../../../../common/react/hooks/use-competition-navigation-options';

import {
    performanceChartDataTypeSelector,
    performanceChartNavSelector,
} from '../../../../store/js/modules/statspro/performance-chart/selectors';

/**
 * @returns {JSX.Element} Component.
 */
export const PerformanceChart = ( { title } ) => {

    const nav = useSelector( performanceChartNavSelector );
    const options = useCompetitionNavigationOptions( nav );
    usePerformanceChartNavSync( options );

    const dataType = useSelector( performanceChartDataTypeSelector );
    const [ showBenchmarking, setShowBenchmarking ] = useState( true );

    useEffect(() => {
        if ( nav.season.id !== -1 ) {
            if ( dataType.type === 'totals' ) {
                setShowBenchmarking( false );
            } else {
                setShowBenchmarking( true );
            }
        } else {
            setShowBenchmarking( true );
        }

    }, [ dataType, nav.season.id ])

    return (
        <StatsSection.Main>
            <StatsSection.Heading isSmallModifier={true}>
                { title }
            </StatsSection.Heading>
            <StatsSection.Nav>
                <StatsSection.NavItems>
                    <StatNavItem />
                    <SeasonNavItem />
                </StatsSection.NavItems>
            </StatsSection.Nav>
            <StatsSection.Content>
                <StatsSection.ContentHeader>
                    <StatsSection.ContentHeaderHeading>
                        <Heading />
                    </StatsSection.ContentHeaderHeading>
                    <StatsSection.ContentHeaderOptions>
                        <DataTypeToggle />
                    </StatsSection.ContentHeaderOptions>
                    { showBenchmarking && (
                    <StatsSection.ContentHeaderBelow>
                        <BenchmarkingLegend />
                        <BenchmarkingExplainer />
                    </StatsSection.ContentHeaderBelow>
                    ) }
                </StatsSection.ContentHeader>
                <StatsSection.ContentBody>
                    <PerformanceChartContainer />    
                </StatsSection.ContentBody>
            </StatsSection.Content>
        </StatsSection.Main>
    );
};

PerformanceChart.propTypes = {
    title: PropTypes.string.isRequired
};